export default "__VITE_ASSET__689de5f5__"